import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutPage.css';
import { ROUTES } from '../../utils/routes';
import { UK_OFFICE, mapsUrl } from "../../utils/offices";

const aboutBanner = process.env.PUBLIC_URL + '/images/about/about-team.jpg';
export default function AboutPage() {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate(ROUTES.HOME);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [aboutPageData, setAboutPageData] = useState({
    about: {},
    site_settings: {}
  });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    console.log("Leadership API calling...");
    fetch(`${process.env.REACT_APP_API_URL}/about-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": process.env.REACT_APP_API_URL_USERNAME,
        "api-password": process.env.REACT_APP_API_URL_PASSWORD
      },
      body: JSON.stringify({})
    })
      .then((response) => {
        console.log("API Status:", response.status);
        return response.json();
      })
      .then((data) => {
        console.log("Leadership API Response:", data);
        setAboutPageData(data);
      })
      .catch((error) => {
        console.log("API Error:", error);
      }).finally(() => {
        setLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <>
      <section className="about-page-banner inner-page-banner" style={{ backgroundImage: `url(${aboutBanner})` }}>
        <div className="about-page-banner-overlay inner-page-banner-overlay" />
        <div className="container about-page-banner-inner inner-page-banner-inner">
          <h1 className="inner-page-banner-title">About Us</h1>
        </div>
      </section>

      <div className="inner-page-breadcrumb-wrap">
        <div className="container">
          <nav className="inner-page-breadcrumb">
            <button type="button" className="inner-page-home" onClick={handleNavigateHome}>Home</button>
            <span className="inner-page-sep"><i className="bi bi-chevron-right" /></span>
            <span className="inner-page-current">About</span>
          </nav>
        </div>
      </div>

      <div dangerouslySetInnerHTML={{ __html: aboutPageData.about.description || "" }} />

      <section className="about-page-contact-strip">
        <div className="container">
          <div className="about-page-contact-inner" data-aos="fade-up">
            <h3>Contact information</h3>
            <p className="about-page-contact-lead">
              Connect with our team for transformation strategy, advisory, and delivery support.
            </p>

            <div className="about-page-contact-grid">
              <a href={`https://maps.google.com/?q=${aboutPageData.site_settings.company_address}`} className="about-page-contact-card" target="_blank" rel="noreferrer">
                <i className="bi bi-geo-alt-fill" />
                <span>Headquarters</span>
                <strong>{aboutPageData.site_settings.company_address}</strong>
              </a>
              <a href={mapsUrl(UK_OFFICE.address)} className="about-page-contact-card" target="_blank" rel="noreferrer">
                <i className="bi bi-geo-alt-fill" />
                <span>{UK_OFFICE.label}</span>
                <strong>{UK_OFFICE.company}, {UK_OFFICE.address}</strong>
              </a>
              <a href={`mailto:${aboutPageData.site_settings.email}`} className="about-page-contact-card">
                <i className="bi bi-envelope-fill" />
                <span>Email</span>
                <strong>{aboutPageData.site_settings.email}</strong>
              </a>
              <a href={`tel:${aboutPageData.site_settings.phone_number}`} className="about-page-contact-card">
                <i className="bi bi-telephone-fill" />
                <span>Phone</span>
                <strong>{aboutPageData.site_settings.phone_number}</strong>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
